import { render, staticRenderFns } from "./Funcao.vue?vue&type=template&id=d307c84e"
import script from "./Funcao.vue?vue&type=script&lang=js"
export * from "./Funcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports